import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { apiGetEmissions, apiUpdateEmission } from "../../../api/ApiEmission";
import { apiGetPublications, apiUpdatePublication } from "../../../api/ApiPublication";
import ComponentTitle from "../../layout/ComponentTitle";
import { useTranslation } from "react-i18next";

const ComponentFocusInspiration = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [emissions, setEmissions] = useState([]);
  const [publications, setPublications] = useState([]);

  const [categorieFocusPrimaire, setCategorieFocusPrimaire] = useState("Medias");
  const [categorieFocusSecondaire1, setCategorieFocusSecondaire1] = useState("Medias");
  const [categorieFocusSecondaire2, setCategorieFocusSecondaire2] = useState("Medias");
  const [categorieFocusSecondaire3, setCategorieFocusSecondaire3] = useState("Medias");
  const [categorieFocusSecondaire4, setCategorieFocusSecondaire4] = useState("Medias");

  const [focusPrimaire, setFocusPrimaire] = useState("");
  const [focusSecondaire1, setFocusSecondaire1] = useState("");
  const [focusSecondaire2, setFocusSecondaire2] = useState("");
  const [focusSecondaire3, setFocusSecondaire3] = useState("");
  const [focusSecondaire4, setFocusSecondaire4] = useState("");

  const recupDatas = async () => {
    const resEmissions = await apiGetEmissions(
      ReduxInstance._id,
      "filter[publie]=true&sort[ordre]=-1"
    );
    const resPublications = await apiGetPublications(
      ReduxInstance._id,
      "filter[publie]=true&sort[ordre]=-1"
    );

    let indiceSecondaire = 1;

    if (resEmissions) {
      setEmissions(resEmissions.data);
      resEmissions.data.forEach((item) => {
        if (item.focusPrimaire) {
          setFocusPrimaire(item._id);
          setCategorieFocusPrimaire("Medias");
        }
        if (item.focusSecondaire) {
          if (indiceSecondaire === 1) {
            setFocusSecondaire1(item._id);
            setCategorieFocusSecondaire1("Medias");
          }
          if (indiceSecondaire === 2) {
            setFocusSecondaire2(item._id);
            setCategorieFocusSecondaire2("Medias");
          }
          if (indiceSecondaire === 3) {
            setFocusSecondaire3(item._id);
            setCategorieFocusSecondaire3("Medias");
          }
          if (indiceSecondaire === 4) {
            setFocusSecondaire4(item._id);
            setCategorieFocusSecondaire4("Medias");
          }
          indiceSecondaire++;
        }
      });
    }

    if (resPublications) {
      setPublications(resPublications.data);
      resPublications.data.forEach((item) => {
        if (item.focusPrimaire) {
          setFocusPrimaire(item._id);
          setCategorieFocusPrimaire("Publications");
        }
        if (item.focusSecondaire) {
          if (indiceSecondaire === 1) {
            setFocusSecondaire1(item._id);
            setCategorieFocusSecondaire1("Publications");
          }
          if (indiceSecondaire === 2) {
            setFocusSecondaire2(item._id);
            setCategorieFocusSecondaire2("Publications");
          }
          if (indiceSecondaire === 3) {
            setFocusSecondaire3(item._id);
            setCategorieFocusSecondaire3("Publications");
          }
          if (indiceSecondaire === 4) {
            setFocusSecondaire4(item._id);
            setCategorieFocusSecondaire4("Publications");
          }
          indiceSecondaire++;
        }
      });
    }
  };

  const saveFocus = async (selectID, type, indice = null) => {
    if (type === "focusPrimaire") {
      /* on enlève l'état du orgunit qui était déjà en focus  */
      if (focusPrimaire) {
        if (categorieFocusPrimaire === "Medias") {
          await apiUpdateEmission(focusPrimaire, { focusPrimaire: false });
        }
        if (categorieFocusPrimaire === "Publications") {
          await apiUpdatePublication(focusPrimaire, { focusPrimaire: false });
        }
      }

      /* On met à jour le nouveau focus */
      if (selectID) {
        if (categorieFocusPrimaire === "Medias") {
          await apiUpdateEmission(selectID, { focusPrimaire: true });
          setFocusPrimaire(selectID);
        }
        if (categorieFocusPrimaire === "Publications") {
          await apiUpdatePublication(selectID, { focusPrimaire: true });
          setFocusPrimaire(selectID);
        }
      } else {
        setFocusPrimaire("");
      }
    }

    if (type === "focusSecondaire") {
      /* focus secondaire 1 */
      if (indice === "focusSecondaire1") {
        if (focusSecondaire1) {
          if (categorieFocusSecondaire1 === "Medias") {
            await apiUpdateEmission(focusSecondaire1, {
              focusSecondaire: false,
            });
          }
          if (categorieFocusSecondaire1 === "Publications") {
            await apiUpdatePublication(focusSecondaire1, {
              focusSecondaire: false,
            });
          }
        }
        if (selectID) {
          if (categorieFocusSecondaire1 === "Medias") {
            await apiUpdateEmission(selectID, { focusSecondaire: true });
            setFocusSecondaire1(selectID);
          }
          if (categorieFocusSecondaire1 === "Publications") {
            await apiUpdatePublication(selectID, { focusSecondaire: true });
            setFocusSecondaire1(selectID);
          }
        } else {
          setFocusSecondaire1("");
        }
      }
      /* focus secondaire 2 */
      if (indice === "focusSecondaire2") {
        if (focusSecondaire2) {
          if (categorieFocusSecondaire2 === "Medias") {
            await apiUpdateEmission(focusSecondaire2, {
              focusSecondaire: false,
            });
          }
          if (categorieFocusSecondaire2 === "Publications") {
            await apiUpdatePublication(focusSecondaire2, {
              focusSecondaire: false,
            });
          }
        }
        if (selectID) {
          if (categorieFocusSecondaire2 === "Medias") {
            await apiUpdateEmission(selectID, { focusSecondaire: true });
            setFocusSecondaire2(selectID);
          }
          if (categorieFocusSecondaire2 === "Publications") {
            await apiUpdatePublication(selectID, { focusSecondaire: true });
            setFocusSecondaire2(selectID);
          }
        } else {
          setFocusSecondaire2("");
        }
      }
      /* focus secondaire 3 */
      if (indice === "focusSecondaire3") {
        if (focusSecondaire3) {
          if (categorieFocusSecondaire3 === "Medias") {
            await apiUpdateEmission(focusSecondaire3, {
              focusSecondaire: false,
            });
          }
          if (categorieFocusSecondaire3 === "Publications") {
            await apiUpdatePublication(focusSecondaire3, {
              focusSecondaire: false,
            });
          }
        }
        if (selectID) {
          if (categorieFocusSecondaire3 === "Medias") {
            await apiUpdateEmission(selectID, { focusSecondaire: true });
            setFocusSecondaire3(selectID);
          }
          if (categorieFocusSecondaire3 === "Publications") {
            await apiUpdatePublication(selectID, { focusSecondaire: true });
            setFocusSecondaire3(selectID);
          }
        } else {
          setFocusSecondaire3("");
        }
      }
      /* focus secondaire 4 */
      if (indice === "focusSecondaire4") {
        if (focusSecondaire4) {
          if (categorieFocusSecondaire4 === "Medias") {
            await apiUpdateEmission(focusSecondaire4, {
              focusSecondaire: false,
            });
          }
          if (categorieFocusSecondaire4 === "Publications") {
            await apiUpdatePublication(focusSecondaire4, {
              focusSecondaire: false,
            });
          }
        }
        if (selectID) {
          if (categorieFocusSecondaire4 === "Medias") {
            await apiUpdateEmission(selectID, { focusSecondaire: true });
            setFocusSecondaire4(selectID);
          }
          if (categorieFocusSecondaire4 === "Publications") {
            await apiUpdatePublication(selectID, { focusSecondaire: true });
            setFocusSecondaire4(selectID);
          }
        } else {
          setFocusSecondaire4("");
        }
      }
    }
  };

  useEffect(() => {
    recupDatas();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentTitle title={t("admin.PageAdminAlaUne.blocInspirationTitre")} />
      <p>{t("admin.PageAdminAlaUne.blocInspirationText")}</p>
      <div className="d-flex flex-column flex-lg-row zoneFocus">
        <div className="m-1 p-3 zoneFocusPrimaire d-flex flex-column justify-content-center">
          <span>{t("admin.PageAdminAlaUne.blocInspirationType")}</span>
          <div className="d-flex p-2">
            <Form.Check
              className="me-5"
              type="radio"
              label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix1")}
              checked={categorieFocusPrimaire === "Medias" ? "checked" : ""}
              onChange={(e) => setCategorieFocusPrimaire("Medias")}
              disabled={focusPrimaire ? "disabled" : ""}
            />
            <Form.Check
              type="radio"
              label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix2")}
              checked={categorieFocusPrimaire === "Publications" ? "checked" : ""}
              onChange={(e) => setCategorieFocusPrimaire("Publications")}
              disabled={focusPrimaire ? "disabled" : ""}
            />
          </div>
          {categorieFocusPrimaire === "Medias" && (
            <Form.Select
              name="focusPrimaire"
              value={focusPrimaire}
              onChange={(e) => saveFocus(e.target.value, "focusPrimaire")}
            >
              <option value="">{t("commun.form.placeholder.choixMediaPremierPlan")}</option>
              {emissions.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.type === "emission" ? "émission " : "podcast "} - {item.nom}
                </option>
              ))}
            </Form.Select>
          )}
          {categorieFocusPrimaire === "Publications" && (
            <Form.Select
              name="focusPrimaire"
              value={focusPrimaire}
              onChange={(e) => saveFocus(e.target.value, "focusPrimaire")}
            >
              <option value="">{t("commun.form.placeholder.choixPublicationPremierPlan")}</option>
              {publications.map((item) => (
                <option value={item._id} key={item._id}>
                  {item.nom}
                </option>
              ))}
            </Form.Select>
          )}
        </div>
        <div className="d-flex flex-column constainerZoneFocusSecondaire">
          <div className="  m-1 p-3 zoneFocusSecondaire d-flex flex-column">
            <span>{t("admin.PageAdminAlaUne.blocInspirationType")}</span>
            <div className="d-flex p-2">
              <Form.Check
                className="me-5"
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix1")}
                checked={categorieFocusSecondaire1 === "Medias" ? "checked" : ""}
                onChange={(e) => setCategorieFocusSecondaire1("Medias")}
                disabled={focusSecondaire1 ? "disabled" : ""}
              />
              <Form.Check
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix2")}
                checked={categorieFocusSecondaire1 === "Publications" ? "checked" : ""}
                onChange={(e) => setCategorieFocusSecondaire1("Publications")}
                disabled={focusSecondaire1 ? "disabled" : ""}
              />
            </div>
            {categorieFocusSecondaire1 === "Medias" && (
              <Form.Select
                name="focusSecondaire1"
                value={focusSecondaire1}
                onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire1")}
              >
                <option value="">{t("commun.form.placeholder.choixMediaSecondPlan")}</option>
                {emissions.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.type === "emission" ? "émission " : "podcast "} - {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
            {categorieFocusSecondaire1 === "Publications" && (
              <Form.Select
                name="focusSecondaire1"
                value={focusSecondaire1}
                onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire1")}
              >
                <option value="">{t("commun.form.placeholder.choixPublicationSecondPlan")}</option>
                {publications.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
          </div>

          <div className="  m-1 p-3 zoneFocusSecondaire d-flex flex-column">
            <span>{t("admin.PageAdminAlaUne.blocInspirationType")}</span>
            <div className="d-flex p-2">
              <Form.Check
                className="me-5"
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix1")}
                checked={categorieFocusSecondaire2 === "Medias" ? "checked" : ""}
                onChange={(e) => setCategorieFocusSecondaire2("Medias")}
                disabled={focusSecondaire2 ? "disabled" : ""}
              />
              <Form.Check
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix2")}
                checked={categorieFocusSecondaire2 === "Publications" ? "checked" : ""}
                onChange={(e) => setCategorieFocusSecondaire2("Publications")}
                disabled={focusSecondaire2 ? "disabled" : ""}
              />
            </div>
            {categorieFocusSecondaire2 === "Medias" && (
              <Form.Select
                name="focusSecondaire2"
                value={focusSecondaire2}
                onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire2")}
              >
                <option value="">{t("commun.form.placeholder.choixMediaSecondPlan")}</option>
                {emissions.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.type === "emission" ? "émission " : "podcast "} - {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
            {categorieFocusSecondaire2 === "Publications" && (
              <Form.Select
                name="focusSecondaire2"
                value={focusSecondaire2}
                onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire2")}
              >
                <option value="">{t("commun.form.placeholder.choixPublicationSecondPlan")}</option>
                {publications.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
          </div>

          {/* <div className="  m-1 p-3 zoneFocusSecondaire d-flex flex-column">
            <span>{t("admin.PageAdminAlaUne.blocInspirationType")}</span>
            <div className="d-flex p-2">
              <Form.Check
                className="me-5"
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix1")}
                checked={categorieFocusSecondaire3 === "Medias" ? "checked" : ""}
                onChange={(e) => setCategorieFocusSecondaire3("Medias")}
                disabled={focusSecondaire3 ? "disabled" : ""}
              />
              <Form.Check
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix2")}
                checked={categorieFocusSecondaire3 === "Publications" ? "checked" : ""}
                onChange={(e) => setCategorieFocusSecondaire3("Publications")}
                disabled={focusSecondaire3 ? "disabled" : ""}
              />
            </div>
            {categorieFocusSecondaire3 === "Medias" && (
              <Form.Select
                name="focusSecondaire3"
                value={focusSecondaire3}
                onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire3")}
              >
                <option value="">{t("commun.form.placeholder.choixMediaSecondPlan")}</option>
                {emissions.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.type === "emission" ? "émission " : "podcast "} - {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
            {categorieFocusSecondaire3 === "Publications" && (
              <Form.Select
                name="focusSecondaire3"
                value={focusSecondaire3}
                onChange={(e) => saveFocus(e.target.value, "focusSecondaire", "focusSecondaire3")}
              >
                <option value="">{t("commun.form.placeholder.choixPublicationSecondPlan")}</option>
                {publications.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
          </div> */}

          {/* <div className="  m-1 p-3 zoneFocusSecondaire d-flex flex-column">
            <span>{t("admin.PageAdminAlaUne.blocInspirationType")}</span>
            <div className="d-flex p-2">
              <Form.Check
                className="me-5"
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix1")}
                checked={
                  categorieFocusSecondaire4 === "Medias" ? "checked" : ""
                }
                onChange={(e) => setCategorieFocusSecondaire4("Medias")}
                disabled={focusSecondaire4 ? "disabled" : ""}
              />
              <Form.Check
                type="radio"
                label={t("admin.PageAdminAlaUne.blocInspirationTypeChoix2")}
                checked={
                  categorieFocusSecondaire4 === "Publications" ? "checked" : ""
                }
                onChange={(e) => setCategorieFocusSecondaire4("Publications")}
                disabled={focusSecondaire4 ? "disabled" : ""}
              />
            </div>
            {categorieFocusSecondaire4 === "Medias" && (
              <Form.Select
                name="focusSecondaire4"
                value={focusSecondaire4}
                onChange={(e) =>
                  saveFocus(
                    e.target.value,
                    "focusSecondaire",
                    "focusSecondaire4"
                  )
                }
              >
                <option value="">
                  {t("commun.form.placeholder.choixMediaSecondPlan")}
                </option>
                {emissions.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.type === "emission" ? "émission " : "podcast "} -{" "}
                    {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
            {categorieFocusSecondaire4 === "Publications" && (
              <Form.Select
                name="focusSecondaire4"
                value={focusSecondaire4}
                onChange={(e) =>
                  saveFocus(
                    e.target.value,
                    "focusSecondaire",
                    "focusSecondaire4"
                  )
                }
              >
                <option value="">
                  {t("commun.form.placeholder.choixPublicationSecondPlan")}
                </option>
                {publications.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.nom}
                  </option>
                ))}
              </Form.Select>
            )}
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ComponentFocusInspiration;
